
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import MDBox from '../../../components/MDBox';
import MDInput from '../../../components/MDInput';
import MDTypography from '../../../components/MDTypography';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const TeamDataStep = () => {
  const { control, formState: { errors } } = useFormContext();

  return (
    <MDBox>
      
      <Grid container spacing={3}>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="اسم الفريق"
                fullWidth
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            )}
          />
        </Grid>
         <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="logo_url"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="رابط الشعار"
                fullWidth
                error={!!errors.logo_url}
                helperText={errors.logo_url?.message}
               
              />
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="subscription_plan"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                select
                label="الخطة"
                fullWidth
                error={!!errors.subscription_plan}
                helperText={errors.subscription_plan?.message}
                sx={{
                  '& .MuiInputBase-root': {
                    padding: '12px !important',
                  },
                }}
              >
                <MenuItem value="basic">اساسية</MenuItem>
                <MenuItem value="premium">ممتازة</MenuItem>
                <MenuItem value="enterprise">تجارية</MenuItem>
              </MDInput>
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="city"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="المدينة"
                fullWidth
                error={!!errors.city}
                helperText={errors.city?.message}
              />
            )}
          />
        </Grid> 
        <Grid item size={{ xs: 12, md: 12 }}>
          <Controller
            name="address"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                label="العنوان"
                fullWidth
                error={!!errors.address}
                helperText={errors.address?.message}
              />
            )}
          />
        </Grid>
        
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="monthly_target"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                type="number"
                label="الهدف الشهري"
                fullWidth
                error={!!errors.monthly_target}
                helperText={errors.monthly_target?.message}
              />
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="max_agents"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                type="number"
                label="عدد الاعضاء"
                fullWidth
                error={!!errors.max_agents}
                helperText={errors.max_agents?.message}
              />
            )}
          />
        </Grid>
        
        <Grid item size={{ xs: 12, md: 6 }}>
          <Controller
            name="monthly_fee"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                type="number"
                label="الرسوم الشهري"
                fullWidth
                error={!!errors.monthly_fee}
                helperText={errors.monthly_fee?.message}
              />
            )}
          />
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
             <LocalizationProvider dateAdapter={AdapterDayjs}>
                 <Controller
                    name="subscription_ends_at"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <DatePicker
                        label="تاريخ انتهاء الاشتراك"
                        value={value}
                        onChange={onChange}
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                error: !!errors.subscription_ends_at,
                                helperText: errors.subscription_ends_at?.message,
                                     sx: {
                      "& .MuiOutlinedInput-root": {
                        padding: "2px !important",
                        
                       
                        color: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "5px 10px !important",
                        height: "auto",
                        color: "text.main",
                        WebkitTextFillColor: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiInputBase-input": {
                        color: "text.main",
                        WebkitTextFillColor: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiPickersSectionList-root": {
                        color: "text.main",
                        fontSize: ".85rem",
                        padding: "12px 10px !important",
                        
                      },
                      "& .MuiPickersSectionList-section": {
                        color: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiPickersSectionList-sectionContent": {
                        color: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiDateSectionInput-input": {
                        color: "text.main",
                        fontSize: ".85rem",
                      },
                      "& input": {
                        color: "text.main",
                        WebkitTextFillColor: "text.main",
                        fontSize: ".85rem",
                      },
                      "& .MuiInputLabel-root": {
                        transform: "translate(14px, 6px) scale(1)",
                        color: "text.main",
                        fontSize: ".85rem",
                        "&.MuiInputLabel-shrink": {
                          transform: "translate(14px, -8px) scale(0.75)",
                        },
                      },
                     "& .MuiPickersOutlinedInput-notchedOutline": {
                      borderColor: "text.border",
                    },
                      
                    },
                            },
                             openPickerButton: {
                    sx: {
                      color: "text.main",
                      padding: "4px",
                    },
                  },
                  openPickerIcon: {
                    sx: {
                      color: "text.main",
                      fill: "text.main",
                      fontSize: "1.1rem",
                    },
                  },
                        }}
                      />
                    )}
                  />
             </LocalizationProvider>
        </Grid>
        <Grid item size={{ xs: 12, md: 6 }}>
           <Controller
            name="status"
            control={control}
            render={({ field }) => (
              <MDInput
                {...field}
                select
                label="الحالة"
                fullWidth
                error={!!errors.status}
                helperText={errors.status?.message}
                sx={{
                  '& .MuiInputBase-root': {
                    padding: '12px !important',
                  },
                }}
              >
                <MenuItem value="active">نشط</MenuItem>
                <MenuItem value="suspended">موقوف</MenuItem>
                <MenuItem value="inactive">غير نشط</MenuItem>
              </MDInput>
            )}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default TeamDataStep;
